import privileges from '@ubeya/shared-web/privileges';
import { RequestTypes } from '@ubeya/shared/hooks/generic/useRequestsTypes';
// import { COMPASS_DE_ORGANIZATION_ID } from '@ubeya/shared/utils/accounts';

// const organizationsWithShiftReleasePtoImplications = [COMPASS_DE_ORGANIZATION_ID];

export const isRequestEligibleForApproval = ({
  typeId,
  enableContractFeature,
  enableContractLeaveManagementFeature,
  myPrivileges,
  // eslint-disable-next-line unused-imports/no-unused-vars
  organizationId = undefined
}) => {
  const hasPrivilegeToApproveRequests = !!myPrivileges[privileges.APPROVE_PTO_REQUESTS];

  if (enableContractFeature) {
    const isAbsenceRequest = typeId === RequestTypes.ABSENCE;
    // let isReleaseRequest = false;
    // if (organizationId && organizationsWithShiftReleasePtoImplications.includes(organizationId)) {
    //   isReleaseRequest = typeId === RequestTypes.RELEASE_SHIFT;
    // }

    if (isAbsenceRequest && !hasPrivilegeToApproveRequests) {
      return false;
    }
  }

  if (enableContractLeaveManagementFeature) {
    const isLeaveRequest = typeId === RequestTypes.LEAVE_REQUEST;

    if (isLeaveRequest && !hasPrivilegeToApproveRequests) {
      return false;
    }
  }

  return true;
};
